module.exports = __webpack_public_path__ + "static/media/sdg_icon_17.d25b3931.png";